import type { MailListItemAnimation } from '../store/schema/MailListItemAnimationStore';

export function cancelAllRowAnimationsForAnimation(animation: MailListItemAnimation): void {
    const activeRowAnimations = animation.rowAnimations;
    if (activeRowAnimations) {
        for (const activeRowAnimation of activeRowAnimations) {
            activeRowAnimation?.cancel();
        }
    }
}
